// Sidebare menu config
const MenuRoutes = [
  {
    navlabel: true,
    name: "MENU",
    icon: "",
  },
  {
    path: "/analytics",
    name: "Analytics",
    icon: "bar-chart-2",
  },
  {
    path: "/users",
    name: "Utenti",
    icon: "users",
  },
  {
    path: "/pos-list",
    name: "Punti vendita",
    icon: "shopping-cart",
  },
  {
    path: "/questions",
    name: "Questionari",
    icon: "list",
  }
];

export default MenuRoutes;
